import { lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './style.css'
const LocalApp = lazy(() => import('./LocalApp.js'))
const ServerApp = lazy(() => import('./server/ServerApp.js'))
const StatusApp = lazy(() => import('./StatusApp.js'))
const root = document.getElementById('root')
if (!root) throw new Error('root_element_missing')
document.documentElement.lang = 'ru'
const internal = location.pathname === '/status' || location.pathname === '/dev/sync'
createRoot(root).render(<Suspense fallback={<p role="status">Открываем пространство…</p>}>{internal ? <StatusApp/> : import.meta.env.VITE_SERVER_MODE === 'true' && location.pathname !== '/local' && location.pathname !== '/own' ? <ServerApp/> : <LocalApp/>}</Suspense>)
